<template >
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-tabs  v-model="tabs" color="#1C3071" grow >
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon >mdi-account-cog</v-icon>
                        <span style="margin-left: 5%"></span>
                        {{$t('administrators')}}
                    </v-tab>
                    <v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-account-group</v-icon>
                        <span style="margin-left: 5%"></span>
                        {{$t('other_users')}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <!--Admins-->
                    <v-tab-item>
                        <v-card flat>
                            <admins/>
                        </v-card>
                    </v-tab-item>
                    <!--OTHER USERS-->
                    <v-tab-item>
                        <v-card flat>
                            <other-users/>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>

        </div>
    </div>

</template>
<script>
    /* eslint-disable */

    import OtherUsers from "./components/users/OtherUsers";
    import Admins from "./components/users/Admins";

    export default {
        components: {Admins, OtherUsers},
        label: "Users",
        data () {
            return {
            tabs:null

            }
        },
        methods:{
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
        },
        computed: {


        },
        mounted(){

        },

        created() {
            this.checkisDashboard();
        },

    }
</script>

<style scoped>
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 50px;
        height: 50px;
        object-fit: contain;
    }
</style>
